/* eslint-disable prettier/prettier */
import React, { createContext, useState } from 'react'
import { json } from 'react-router-dom';
const AuthContext = createContext({})
// eslint-disable-next-line react/prop-types
export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState({});
    if (Object.keys(auth).length === 0) {
        let loggedInUser = localStorage.getItem('auth')
        if (loggedInUser != null) {
            loggedInUser = JSON.parse(loggedInUser)
            if (Object.keys(loggedInUser).length > 0) {
                setAuth(loggedInUser)
            }
        }
    }
    return <AuthContext.Provider value={{ auth, setAuth }}>{children}</AuthContext.Provider>
}
export default AuthContext